// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"d8174885","879":"73845473"}[chunkId] + ".chunk.js";
};